import {GenericDialogContextActions, IGenericDialogContextState} from './context.ts'
import {Reducer} from 'react';

export const GenericDialogV2Reducer: Reducer<IGenericDialogContextState, GenericDialogContextActions>
    = (state: IGenericDialogContextState, action: GenericDialogContextActions): IGenericDialogContextState => {
        switch (action.type) {
        case 'setCtxState':
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            }
        default:
            return state
        }
    }
